import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M4 13h3l3 3h4l3 -3h3","key":"svg-1"}]]

const IconInbox = createReactComponent('outline', 'inbox', 'Inbox', __iconNode);

export default IconInbox;